<template>
    <el-dialog :visible.sync="visible" :modal-append-to-body="false" :show-close="false" class="eos__dialog" width="30%">
        <div class="eos__dialog--content">
            <h2>Remove Service</h2>
            <p>Are you sure you want to remove this service?</p>
            <div class="eos__dialog--content--footer">
                <button class="eos__dialog--content--footer--btn__cancel" @click="$emit('cancel')">Cancel</button>
                <button class="eos__dialog--content--footer--btn__confirm" @click="$emit('confirm')">Confirm</button>
            </div>
        </div>
    </el-dialog>
</template>
<script>
export default {
    props: {
        visible: Boolean
    }
}
</script> 


// WEBPACK FOOTER //
// src/components/eos/components/EosRemoveServiceDialog.vue